import axios from 'axios'

import { unique } from '@/helpers/api'
import type { PageNumberPagination } from '@/types'
import type { Secret, SecretLight } from '@/types/secret'

import type { PageNumberPaginationParameters } from '.'

export const listSecrets = unique(
  async (params: PageNumberPaginationParameters): Promise<PageNumberPagination<SecretLight>> =>
    (await axios.get('/secret/', { params })).data,
)

export const retrieveSecret = unique(
  async (name: string): Promise<Secret> => (await axios.get(`/secret/${name}`)).data,
)

export const createSecret = async (
  payload: Pick<Secret, 'name' | 'content'>,
): Promise<SecretLight> => (await axios.post('/secret/', payload)).data

export const updateSecret = async (
  name: string,
  payload: Partial<Pick<Secret, 'name' | 'content'>>,
): Promise<Secret> => (await axios.patch(`/secret/${name}`, payload)).data

export const destroySecret = async (name: string) => await axios.delete(`/secret/${name}`)
